import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../fragments/__generated__/PageInfo.generated';
import { UserTranslationFragmentDoc } from '../../fragments/__generated__/UserTranslation.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserTranslationsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  language?: Types.InputMaybe<Types.LanguageEnum>;
  status?: Types.InputMaybe<Types.TranslationStatusEnum>;
  entityType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  fieldName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  entityId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  user: Types.Scalars['ID']['input'];
}>;


export type UserTranslationsQuery = { userTranslations: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ node: { id: string, pk: number, originalText: string, currentText: string, entityType: string, entityId: number | null, fieldName: string, language: Types.LanguageEnum, status: Types.TranslationStatusEnum } }> } };


export const UserTranslationsDocument = gql`
    query UserTranslations($first: Int!, $language: LanguageEnum, $status: TranslationStatusEnum, $entityType: String, $fieldName: String, $entityId: Int, $user: ID!) {
  userTranslations(
    first: $first
    filters: {language: $language, status: $status, entityType: $entityType, fieldName: $fieldName, entityId: $entityId, user: {pk: $user}}
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        ...UserTranslationFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${UserTranslationFragmentDoc}`;

/**
 * __useUserTranslationsQuery__
 *
 * To run a query within a React component, call `useUserTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTranslationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      language: // value for 'language'
 *      status: // value for 'status'
 *      entityType: // value for 'entityType'
 *      fieldName: // value for 'fieldName'
 *      entityId: // value for 'entityId'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserTranslationsQuery(baseOptions: Apollo.QueryHookOptions<UserTranslationsQuery, UserTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTranslationsQuery, UserTranslationsQueryVariables>(UserTranslationsDocument, options);
      }
export function useUserTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTranslationsQuery, UserTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTranslationsQuery, UserTranslationsQueryVariables>(UserTranslationsDocument, options);
        }
export type UserTranslationsQueryHookResult = ReturnType<typeof useUserTranslationsQuery>;
export type UserTranslationsLazyQueryHookResult = ReturnType<typeof useUserTranslationsLazyQuery>;
export type UserTranslationsQueryResult = Apollo.QueryResult<UserTranslationsQuery, UserTranslationsQueryVariables>;
export function refetchUserTranslationsQuery(variables: UserTranslationsQueryVariables) {
      return { query: UserTranslationsDocument, variables: variables }
    }